import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import WhatsAppButton from "@/components/ui/WhatsAppButton";
const AboutTaxHealth: React.FC = () => {
  return <section id="sobre-taxhealth" className="py-10 md:py-16 px-4 md:px-6 bg-background">
      <div className="container mx-auto max-w-5xl">
        <div className="text-center mb-8 md:mb-10">
          <p className="text-xs tracking-widest font-medium uppercase text-primary mb-2">
            CONHEÇA A EMPRESA
          </p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3">
            O que fazemos por você?
          </h2>
          <p className="text-base md:text-lg text-muted-foreground">
            Gestão tributária especializada para profissionais da saúde
          </p>
        </div>

        <Card className="shadow-sm">
          <CardContent className="p-4 md:p-6 space-y-4 text-muted-foreground leading-relaxed">
            <p>
              <strong className="text-foreground">A Tax Health ajuda a gerenciar melhor seus impostos de forma simples e eficiente.</strong>
            </p>
            <p>
              Nossos especialistas analisam a situação tributária da sua empresa e identificam oportunidades específicas para <strong className="text-foreground">redução de impostos</strong>.
            </p>
            <p>
              Depois, implementamos ações 100% administrativas que reduzem até <strong className="text-foreground">65% de sua carga tributária mensal</strong>, garantindo um fluxo de caixa saudável e maior lucratividade.
            </p>
            <p>
              Além disso, recuperamos os valores pagos em excesso nos últimos 60 meses, com restituição corrigida.
            </p>
            <p>
              Nossa equipe está sempre atualizada em relação à legislação tributária, oferecendo consultoria personalizada e totalmente legal.
            </p>
            <p>
              Atendemos exclusivamente <strong className="text-foreground">médicos, clínicas, laboratórios e hospitais</strong>, o que nos permite compreender as necessidades específicas do setor da saúde e oferecer soluções sob medida.
            </p>

            <div className="pt-4">
              <WhatsAppButton text="Falar com um especialista" source="about_section" size="lg" className="w-full md:w-auto" showIcon={false} />
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
};
export default AboutTaxHealth;